const en = {
  translation: {
    menuPrincipal: {
      home: "Home",
      sobreNos: "About us",
      servicos: "Services",
      contato: "Contact us",
    },
    banner: {
      conectar: "Connect",
    },
    secaoSobre: {
      titulo: "WE ARE SAGRES!",
      primeiroParagrafo:
        "Inspired by the historic School of Sagres, whose purpose was to advance navigation and open new trade routes, SAGRES shares the same pioneering spirit: delivering strategic solutions in international procurement for your business.",
      segundoParagrafo:
        "With technology as our ally, we remove barriers and reduce costs, enabling our customers to internationalize efficiently.",
      terceiroParagrafo:
        "Through a global network of suppliers, we identify the ideal product for each need while ensuring compliance with Brazilian legislation.",
      card: {
        primeiroCard: {
          titulo: "OUR MISSION",
          descricao:
            "To deliver procurement solutions for Brazilian companies, removing barriers to international trade.",
        },
        segundoCard: {
          titulo: "OUR VISION",
          descricao:
            "To be the market reference for expertise in international procurement.",
        },
        terceiroCard: {
          titulo: "OUR VALUES",
          descricao:
            "Integrity, transparency in negotiations, and agile service delivery.",
        },
      },
    },
    secaoServico: {
      titulo: "",
      descricao: "",
      titulos: {
        primeiroTitulo: "OUR SERVICE: PROCUREMENT",
        subtitulo: "HOW WE WORK",
      },
      cardInformacao: {
        item1: "Initial Analysis",
        desc1:
          "We receive your request, perform a detailed diagnosis, and define the search parameters.",
        item2: "Global Research",
        desc2:
          "We leverage our database of millions of companies to identify potential suppliers.",
        item3: "Qualified Screening",
        desc3:
          "We contact, evaluate, and select suppliers with the highest potential for success.",
        item4: "Sample Validation",
        desc4:
          "We manage samples from the most aligned suppliers until final approval.",
        item5: "Cost and Operations",
        desc5:
          "We connect you with our trading department, when necessary, to prepare import cost estimates and ensure operational alignment.",
      },
    },
    secaoDiferencial: {
      titulo: "OUR",
      subtitulo: "DIFFERENTIALS",
      primeiroDiferencial: "AGILITY",
      descricaoPrimeiroDiferencial:
        "Robust database with information on millions of companies across different markets, enhancing efficiency and speed in service delivery.",
      segundoDiferencial: "EXPERTISE",
      descricaoSegundoDiferencial:
        "Highly qualified team of specialists in international procurement, ready to identify the right suppliers for your business.",
      terceiroDiferencial: "CREDIBILITY",
      descricaoTerceiroDiferencial:
        "Our analysis uses global sources of international reference, applying rigor and consistency throughout the entire search process.",
    },
    formulario: {
      inputNome: "Your Name",
      inputEmail: "Your E-mail",
      inputMensagem: "Your Message...",
      titulo: "CONTACT US",
      enviar: "Send",
    },
    swall: {
      titulo: "Thank you",
      texto: "Email sent",
    },
    agradecimento: {
      tituloBotao: "Go back",
    },
  },
};

export { en };
